import { render } from "./template.html?vue&type=template&id=05a47c3e"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&lang=css"

import exportComponent from "/n/www/reich-ages.rc.hms.harvard.edu/AGES/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__